import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  IconButton,
  Skeleton,
  Button
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';

interface ReviewSectionProps {
  title: string;
  tabIndex: number;
  onEdit: (tabIndex: number) => void;
  isEmpty?: boolean;
  isLoading?: boolean;
  emptyMessage?: string;
  visibilityChip?: React.ReactNode;
  children: React.ReactNode;
}

export const ReviewSection: React.FC<ReviewSectionProps> = ({
  title,
  tabIndex,
  onEdit,
  isEmpty = false,
  isLoading = false,
  emptyMessage = 'No data entered yet',
  visibilityChip,
  children
}) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <Box>
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="rectangular" height={40} sx={{ mt: 1 }} />
        </Box>
      );
    }

    if (isEmpty) {
      return (
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {emptyMessage}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => onEdit(tabIndex)}
          >
            Go to {title}
          </Button>
        </Box>
      );
    }

    return children;
  };

  return (
    <Card elevation={0} sx={{ mb: 2, border: 'none', boxShadow: 'none' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6" component="h3">
              {title}
            </Typography>
            {visibilityChip}
          </Box>
          <IconButton
            size="small"
            onClick={() => onEdit(tabIndex)}
            aria-label={`Edit ${title}`}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Box>
        {renderContent()}
      </CardContent>
    </Card>
  );
};
